export default __webpack_public_path__ + "static/media/polygon.076e864d.svg";